import { combineReducers } from "redux";
import fetchDataReducer from "./fetchDataReducer";
import authReducer from "./authReducer";
import docReducer from "./docReducer";
import profileReducer from "./profileReducer";
import chekckUserReducer from "./chekckUserReducer";
import skillListingReducer from "./skillListingReducer";
import credentialingReducer from "./credentialingReducer";
import createBidReducers from "./createBidReducers";
import updateBidReducers from "./updateBidReducers";
import messagesReducer from "./messagesReducer";
import updateProposalReducers from "./updateProposalReducer";
import appReducer from "./appReducer";
import retractBidReducers from "./retractReducer";
// import getChatHistoryReducer from "./chatHistoryReducer";
import createInterviewReducer from "./createInterviewReducer";
import updateInterviewReducer from "./updateInterviewReducer";
import getProfileDetailsReducer from "./ProfileDetailsReducer";
import updatePersonalDetailsReducer from "./updatePersonalDetailsReducer";
import searchSkillListingReducer from "./searchSkillListingReducer";
import getSearchSuggestionReducer from "./searchSuggestionReducer";
import getCompanyProfileDetailsReducer from "./getCompanyProfileDetailsReducer";
import getPersonalDetailsLocationReducer from "./getPersonalDetailsLoactionReducer";
import getCompanyDetailsReducer from "./CompanyDetailsReducer";
import fetchAllGigsReducer from "./fetchAllGigsReducer";
import getCulturePhotos from "./OurCultutrePhotosReducer";
import getViewsReducer from "./getViewsReducer";
import fetchAlbumsReducer from "./fetchAlbumsReducer";
import createGigReducer from "./createGigReducer";
import getSearchSkillsReducer from "./getSearchSkillsReducer";
import updateGigReducer from "./updateGigReducer";
import getFollowersReducer from "./getFollowersReducer";
import updateEmpAlbumsReducer from "./updateEmpAlbumsReducer";
import editEmpAlbumsReducer from "./editEmpAlbumsReducer";
import deleteEmpAlbumsReducer from "./deleteEmpAlbumsReducer";
import getGigsReducer from "./getGigsReducer";
import manageJobsReducer from "./manageJobsReducer";
import oneUserskillListingReducer from "./oneUserskillListingReducer";
import postJObReeducer, { UpdateJobReducer } from "./postJobReducer";
import deleteJobReducer from "./deleteJobReducer";
import getJobDetailReducer from "./getJobDetailReducer";
import dashbaordReducer from "./DashboardReducer";
import getResume3dReducer from "./getResume3dReducer";
import getAllInterviewsReducer from "./getAllInterviewsReducer";
import MatchedSkillReducer from "./SkillMacthesReducer";
import favoritesReducer from "./FavoritesReducer";
import roleReducer from "./RoleReducer";
import TimesheetListReducer, {
  TimesheetDetailsReducer,
  timesheetGraphReducer,
} from "./TimesheetReducer";
import rejectTimeSheetReducer from "./RejectTimeSheetReducer";
import TeamMembersReducer from "./TeamMembersReducer";
import TeamPageReducer from "./TeamPageReducer";
import updateTeamMembersReducer from "./UpdateTeamMemebersReducer";
import reactivateTeamMembersReducer from "./reactivateTeamMembersReducer";
import searchCandidateMarketReducer from "./searchCandidateMarketReducer";
import fetchNotificationReducer from "./fetchNotificationReducer";
import followReducer from "./followReducer";
import unFollowReducer from "./unFollowReducer";
import getMatchesReducer from "./MyMatchesReducer";
// import getAllPaymentsReducer from "./getAllPaymentsReducer";
import getAllPaymentsReducer from "./getAllPaymentsReducer";
//import manageJobsReducer from "./manageJobsReducer";
import ratingReducer from "./ratingsReducer";
import messageFavouriteReducer from "./messageFavouriteReducer"
import getCandidatesReducer from "./getCandidatesReducer";
import followUnFollowReducer from "./followUnFollowReducer";
import checkUserNameReducer from "./checkUserNameReducer";
import getRecentgigReducer from "./getRecentgigReducer";
import manageDraftJobsReducer from "./manageDraftJobsReducer";
import getCandidatesCountsReducer from "./getCandidatesCountsReducer";
import getCompanyGigsReducer from "./GetCompanyGigsReducer";
import viewIncrementReducer from "./viewIncrementReducer";
import conversationFavReducer from "./conversationFavouriteReducer";
import getRatingReducer from "./getRatingReducer";
import myGigsFilterReducer from "./myGigsFilterReducer";
import userTrackingReducer from "./userTrackingReducer";
import getHRMDetailsReducer from "./hrmReducer";
import absReducer from './absReducer';
import candidateSkillReducer from './candidateSkillReducer'
import candidateReducer from './candidateReducer'
import invitedCandidatesReducer from './invitedCandidatesReducer'
import inviteTrackingInvitesReducer from './inviteTrackingInvitesReducer'
import configTimeSheetReducer from './configTimeSheetReducer';
import TimeOffReducer from './timeOffReducer';
import vmsFilterReducer from "./VmsFilterReducer";
import TagReduer from "./TagReducer";
import VmsFacilityReducer from "./VmsFacilityReducer";
import searchExternalUsersReducer from "./searchExternalUsersReducer";
import associatedTalentsReducer from "./associatedTalentsReducer";
import queryPageSkillListingReducer from "./queryPageSkillListingReducer";
import externalUserDetailReducer from "./externalUserDetailReducer";
import nlSearchExternalReducer from "./nlSearchExternalReducer";
import plansReducer from "./plansReducer";
import { writeWithAiReducer } from "./writeWithAiReducer";
import departmentSearchReducer from "./departmentSearchReducer";
import talentSearchReducer from "./talentSearchReducer";
import createProjectReducer from "./createProjectReducer";
import fetchProjectsReducer from "./fetchProjectsReducer";
import projectDetailReducer from "./projectDetailReducer";
import updateProjectReducer from "./updateProjectReducer";

export default combineReducers({
  fetchDataReducer,
  authReducer,
  docReducer,
  checkUserNameReducer,
  profileReducer,
  chekckUserReducer,
  skillListingReducer,
  updateProposalReducers,
  // appReducer
  credentialingReducer,
  messageFavouriteReducer,
  createBidReducers,
  updateBidReducers,
  messagesReducer,
  retractBidReducers,
  // getChatHistoryReducer,
  conversationFavReducer,
  createInterviewReducer,
  updateInterviewReducer,
  getProfileDetailsReducer,
  updatePersonalDetailsReducer,
  searchSkillListingReducer,
  getSearchSuggestionReducer,
  getCompanyProfileDetailsReducer,
  getCompanyGigsReducer,
  getPersonalDetailsLocationReducer,
  fetchAllGigsReducer,
  getCompanyDetailsReducer,
  getViewsReducer,
  getCulturePhotos,
  fetchAlbumsReducer,
  createGigReducer,
  getSearchSkillsReducer,
  updateGigReducer,
  getFollowersReducer,
  updateEmpAlbumsReducer,
  editEmpAlbumsReducer,
  deleteEmpAlbumsReducer,
  getGigsReducer,
  manageJobsReducer,
  oneUserskillListingReducer,
  postJObReeducer,
  deleteJobReducer,
  getJobDetailReducer,
  dashbaordReducer,
  roleReducer,
  getResume3dReducer,
  getAllInterviewsReducer,
  MatchedSkillReducer,
  favoritesReducer,
  TimesheetListReducer,
  fetchNotificationReducer,
  TeamMembersReducer,
  TeamPageReducer,
  updateTeamMembersReducer,
  reactivateTeamMembersReducer,
  searchCandidateMarketReducer,
  TimesheetDetailsReducer,
  followReducer,
  unFollowReducer,
  timesheetGraphReducer,
  UpdateJobReducer,
  getMatchesReducer,
  getAllPaymentsReducer,
  getCandidatesReducer,
  rejectTimeSheetReducer,
  ratingReducer,
  followUnFollowReducer,
  getRecentgigReducer,
  manageDraftJobsReducer,
  getCandidatesCountsReducer,
  viewIncrementReducer,
  getRatingReducer,
  myGigsFilterReducer,
  userTrackingReducer,
  getHRMDetailsReducer,
  candidateSkillReducer,
  absReducer,
  candidateReducer,
  invitedCandidatesReducer,
  inviteTrackingInvitesReducer,
  configTimeSheetReducer,
  TimeOffReducer,
  vmsFilterReducer,
  TagReduer,
  VmsFacilityReducer,
  searchExternalUsersReducer,
  associatedTalentsReducer,
  queryPageSkillListingReducer,
  externalUserDetailReducer,
  nlSearchExternalReducer,
  plansReducer,
  writeWithAiReducer,
  departmentSearchReducer,
  talentSearchReducer,
  createProjectReducer,
  fetchProjectsReducer,
  projectDetailReducer,
  updateProjectReducer,
});
